import { ValidateRule } from '../constant/validateRules';
import { i18n } from '@/i18n';

/**
 * エラーメッセージの生成ファクトリークラス
 */
export class FormErrorMessageFactory {
  private static t = i18n.t;

  private static errorMessageMap: Record<ValidateRule, string> = {
    [ValidateRule.Required]: 'フォーム:記入必須です',
    [ValidateRule.HalfWidthNumber]: 'フォーム:半角数字で入力してください',
    [ValidateRule.NegativeNumber]: 'フォーム:正の数を入力してください',
    [ValidateRule.HalfWidthRealNumber]: 'フォーム:半角で数値を入力してください',
    [ValidateRule.MemoInvalidChar]: 'フォーム:登録できない文字が含まれています',
    [ValidateRule.MemoTooMuchLength]: 'フォーム:最大登録文字数は255文字です',
  };

  private static prioritizedRules = [
    ValidateRule.HalfWidthNumber,
    ValidateRule.HalfWidthRealNumber,
    ValidateRule.NegativeNumber,
    ValidateRule.Required,
    ValidateRule.MemoInvalidChar,
    ValidateRule.MemoTooMuchLength,
  ];

  /**
   * エラーメッセージの生成
   * @param rules - バリデーションルール
   */
  public static create(rules: readonly ValidateRule[]): string {
    if (!rules || rules.length === 0) {
      return '';
    }

    const matchedRule = this.prioritizedRules.find((rule) => rules.includes(rule));
    return matchedRule ? this.errorMessageMap[matchedRule] : '';
  }
}
